import { useCallback, useContext } from 'react'
import { LocalizationContext } from '@/components/localization'

const indicateMissingTranslation = (key = '') => {
  // if the key represents a resource key - return it enclosed in brackets
  if (/^\S+[:.]\S+$/.test(key)) { return `[${key}]` }

  // if not, it is already translated text - return as it is
  return key
}

export function useLocalization () {
  const context = useContext(LocalizationContext)

  const localize = useCallback((key, params = undefined, localizeParams = true) => {
    const interpolateParams = (value, params) => {
      return value && params && params.length
        ? value.replace(/{(\d+)}/g, (match, number) => {
          return typeof params[number] !== 'undefined'
            ? localizeParams
              ? localize(params[number])
              : params[number]
            : match
        })
        : value
    }

    return key
      ? (interpolateParams(context.data[key] || context.data[key.replace(':', '.')], params) ||
      indicateMissingTranslation(key))
      : ''
  }, [context.data])
  const localizeValue = useCallback((value, latinValue) => {
    return (context.locale === 'en' ? (latinValue || value) : (value || latinValue)) || ''
  }, [context.locale])

  const localizeProps = useCallback((propName = 'name', latinPropName = 'latinName') => {
    return (context.locale === 'en' ? (latinPropName || propName) : (propName || latinPropName)) || ''
  }, [context.locale])

  const localizeEnum = useCallback((enumName, value) => {
    return localize(`Enums.${enumName}_${value}`)
  }, [localize])

  return {
    locale: context.locale,
    rtl: context.locale === 'ar',
    localeDependentComponentKey: context.localeDependentComponentKey,
    localize,
    localizeEnum,
    localizeValue,
    localizeProps,
    localizationData: context.data
  }
}



// WEBPACK FOOTER //
// ./src/hooks/localization.js